// =====================================================
// SCHEMA: CALL
// Description: Schéma Zod pour la consignation d'appels
// =====================================================

import { z } from 'zod';

export const logCallSchema = z
  .object({
    direction: z.enum(['incoming', 'outgoing']),
    outcome: z.enum(['answered', 'voicemail', 'no_answer']),
    duration: z.number().min(0).optional(),
    notes: z.string().optional(),
    create_task: z.boolean().optional(),
    task_date: z.string().optional(),
    task_time: z.string().optional(),
  })
  .refine(
    (data) => {
      // Si create_task est true, task_date doit être renseigné
      if (data.create_task === true) {
        return !!data.task_date;
      }
      return true;
    },
    {
      message: 'La date de relance est obligatoire',
      path: ['task_date'],
    }
  );

export type LogCallInput = z.infer<typeof logCallSchema>;
